import { motion } from "framer-motion";
import Lottie from "react-lottie-player";
import OWDA from "../assets/owda.json";

const Award = () => {
  return (
    <>
      <motion.a
        className="award"
        id="OrpetronAward"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.75 }}
        href="https://orpetron.com/sites/adcanis-portfolio/"
        target="_blank"
        rel="noreferrer"
        style={{
          backgroundImage: `url(${OWDA})`,
        }}
      >
        <Lottie animationData={OWDA} />
      </motion.a>
    </>
  );
};

export default Award;
